import React from "react";
import { connect } from "react-redux";

import { Dispatch, bindActionCreators } from "redux";

import { Form, Text } from "@plex/react-components";

import { useLocalizedValues, useLocalizer } from "ui/hooks";

import { releaseMessages } from "../../release.localization";
import { IReleaseDetailsState } from "../ReleaseDetails.state";

interface IReleaseDetailsProps {
  releaseIdParameter: string;
  status: string;
  releaseName: string;
}

const ReleaseId: React.FC<IReleaseDetailsProps> = ({ status, releaseName }) => {
  const localizer = useLocalizer();
  const localizedValues = useLocalizedValues(() => ({
    name: releaseMessages.property("releaseName"),
    status: releaseMessages.property("status"),
    freezeButtonText: releaseMessages.action("freezeRelease"),
    shipButtonText: releaseMessages.action("shipRelease")
  }));

  const renderReleaseIdField = (
    <Form.FieldPair labelText={localizedValues.name}>
      <Text text={releaseName} as="label" />
    </Form.FieldPair>
  );

  const renderStatusField = (
    <Form.FieldPair labelText={localizedValues.status}>
      <Text text={status && localizer({ value: status })} as="label" />
    </Form.FieldPair>
  );

  return (
    <>
      <Form.Row>{renderReleaseIdField}</Form.Row>
      <Form.Row>{renderStatusField}</Form.Row>
    </>
  );
};

export default connect(
  (state: { releaseDetails: IReleaseDetailsState }) => {
    return {
      status: state.releaseDetails.releaseStatus,
      releaseName: state.releaseDetails.releaseName
    };
  },
  (dispatch: Dispatch) => bindActionCreators({}, dispatch)
)(ReleaseId);
